export const login = {
  path: "/",
  name: "login",

  component: () =>
    import(/* webpackChunkName: "home" */ "@/views/LoginPage.vue"),
};
